
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EvBookingAgendaSwitch.html?raw';
import _TabEnabledMixin from '../../moreCore/UI/Tabbing/_TabEnabledMixin';

import AgendaView from './EvBookingAgenda';
import MonthColumnPlanMinimalMode from '../MonthColumnPlan_TS/MonthColumnPlanMinimalMode/MonthColumnPlanMinimalMode';

class EvBookingAgendaSwitch extends compose(_TabEnabledMixin) {
    /*
    
    Dieses Widget gibt es eigentlich nur, weil wir im ASP.net razor/controler features nicht abfragen koennen.
    Aber wenn das eh am Ende in ein Webpack liegt, ist der Overhead nicht ganz so wild.... warscheinlich .-.
    
    */

    templateString: any = template;

    private mainContentContainer: HTMLDivElement;

    mainWidget: MdsLax<InstanceType<typeof AgendaView>> | MdsLax<InstanceType<typeof MonthColumnPlanMinimalMode>>;

    _onEmbedding() {
        if (this.hasFeature("MonthColumnPlaner", "replaceAgendaView")) {
            this.mainWidget = new MonthColumnPlanMinimalMode();
        } else {
            this.mainWidget = new AgendaView();
        }

        this.mainWidget.placeAt(this.mainContentContainer);
    }
    postCreate() {
        super.postCreate.apply(this, arguments as any);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }

}

export default mdsWidget(EvBookingAgendaSwitch);

